(function() {
  const videos = document.querySelectorAll('.video-hero__inner video');
  const soundToggles = document.querySelectorAll('.video-hero__inner .sound-toggle');

  if (videos.length === 0) return;

  let matchMediaMobile = window.matchMedia('(max-width: 38em)').matches;
  
  function toggleVideos() {
    matchMediaMobile = window.matchMedia('(max-width: 38em)').matches;

    videos.forEach((video) => {
      if (matchMediaMobile) {
        if (
          video.classList.contains('video-hero__video--desktop') &&
          video.classList.contains('video-hero__video--has-mobile')
        ) {
          video.pause();
        } else if (
          video.classList.contains('video-hero__video--mobile') &&
          video.classList.contains('video-hero__video--has-mobile')
        ) {
          video.play().catch((error) => {
            console.error('Autoplay error:', error);
          });
        }
      } else {
        if (
          video.classList.contains('video-hero__video--desktop') &&
          video.classList.contains('video-hero__video--has-mobile')
        ) {
          video.play().catch((error) => {
            console.error('Autoplay error:', error);
          });
        } else if (
          video.classList.contains('video-hero__video--mobile') &&
          video.classList.contains('video-hero__video--has-mobile')
        ) {
          video.pause();
        }
      }
    });
  }

  const debouncedToggleVideos = window.debounce(toggleVideos, 100);
  
  window.addEventListener('DOMContentLoaded', toggleVideos);
  window.addEventListener('resize', debouncedToggleVideos);

  if (soundToggles.length === 0) return;

  soundToggles.forEach((soundToggle) => {
    soundToggle.addEventListener('click', (e) => {
      const videos = e.currentTarget.closest('.video-hero__inner')?.querySelectorAll('video');

      if (videos.length === 0) return;

      videos.forEach((video) => {
        if (video.muted) {
          video.muted = false;
          video.volume = 1;
          e.currentTarget.classList.remove('muted');
        } else {
          video.muted = true;
          e.currentTarget.classList.add('muted');
        }
      });
    });
  });
})();